import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Sidebar() {
  const { isDev } = useAuth();
  return (
    <div className="w-64 bg-blue-500 text-white p-4">
      <h2 className="text-2xl font-semibold mb-8">Dashboard</h2>
      <ul className="space-y-4">
        <li><Link to="/login" className="hover:text-gray-400">Login</Link></li>
        <li><Link to="/" className="hover:text-gray-400">Home</Link></li>
        <li><Link to="/about" className="hover:text-gray-400">About</Link></li>
        <li><Link to="/profile" className="hover:text-gray-400">Profile</Link></li>
        <li><Link to="/documents" className="hover:text-gray-400">Documents</Link></li>
        <li><Link to="/policies" className="hover:text-gray-400">Policies</Link></li>
        <li><Link to="/printoffs" className="hover:text-gray-400">Print Offs</Link></li>
        <li><Link to="/bible" className="hover:text-gray-400">Bible</Link></li>
        {isDev && (
          <li>
            <NavLink
              to="/dev-archive"
              className={({ isActive }) =>
                `block px-4 py-2 rounded ${isActive ? 'bg-blue-600 text-white' : 'hover:bg-blue-50'}`
              }
            >
              Archive (Dev)
            </NavLink>
          </li>
        )}
      </ul>
    </div>
  );
}